import { Injectable } from '@angular/core';
import { combineLatest, Observable, of } from 'rxjs';
import { map, shareReplay, switchMap } from 'rxjs/operators';
import { ApiDocsRemote } from '../../infrastructure/api-docs.remote';
import { BrandingService, defaultCalendarLinkUrl, AdvisorWithDisplayPhone } from 'common';
import { BrokerFacade } from '../../../../broker/domain/+state/broker.facade';
import { AdvisorWidgetData } from 'projects/partner/src/app/shared/advisor-widget/domain/model/advisor-widget.model';
import { AdvisorFacade } from 'common';

@Injectable({
  providedIn: 'root'
})
export class ApiDocsFacade {
  private docsJson$: Observable<string> | null = null;

  constructor(
    private remote: ApiDocsRemote,
    private brokerService: BrokerFacade,
    private brandingService: BrandingService,
    private advisorFacade: AdvisorFacade
  ) {}

  getDocsJson(): Observable<string> {
    if (!this.docsJson$) {
      this.docsJson$ = this.remote.getDocsJson().pipe(
        shareReplay(1)
      );
    }
    return this.docsJson$;
  }

  getAdvisorData$(): Observable<AdvisorWidgetData> {
    return this.brokerService.getBrokerDataDetails$()
      .pipe(
        switchMap((brokerData) => {
          if (brokerData?.advisorId) {
            return this.advisorFacade.getAdvisorWithPhone$(brokerData.advisorId)
              .pipe(map((advisorData) => this.mapToAdvisorWidgetData(advisorData)));
          }
          return combineLatest([this.brandingService.getBranding$()])
            .pipe(map(([brandingData]) => ({
              avatar: null,
              name: null,
              email: null,
              phone: brandingData?.phone,
              calendarUrl: defaultCalendarLinkUrl
            })));
        })
      );
  }

  private mapToAdvisorWidgetData(advisorData: AdvisorWithDisplayPhone | null): AdvisorWidgetData {
    return {
      avatar: advisorData?.avatar,
      name: advisorData?.fullName,
      email: advisorData?.email,
      phone: advisorData?.displayPhone,
      calendarUrl: advisorData?.calendarLinkUrl ?? defaultCalendarLinkUrl
    };
  }
}
